module.exports = __webpack_public_path__ + "img/hederprofileactive.0d51ee58.svg";